import { Apps } from './types';

type AccountLevelKeyName = { translationKey: string; name: string };

export const accountLevelNameByApp: Partial<
  Record<Apps, { standard: AccountLevelKeyName; premium: AccountLevelKeyName }>
> = {
  Rakbank: {
    standard: {
      translationKey: 'rakbank_account_level_standard_plan',
      name: 'rakbank_select',
    },
    premium: {
      translationKey: 'rakbank_account_level_premium_plan',
      name: 'rakbank_elite',
    },
  },
};
